export enum MethodesFetch {
    GET = "GET",
    POST = "POST",
    PUT = "PUT",
    DELETE = "DELETE"
};



// WEBPACK FOOTER //
// ./src/shared/Enums/ServicesFactory/MethodesFetch.ts